import React from 'react';
import { Box, Typography } from '@mui/material';

const GPSTracking: React.FC = () => {
  return (
    <Box p={3}>
      <Typography variant="h2">GPS Tracking</Typography>
      <Typography variant="body1" sx={{ mt: 2 }}>
        Placeholder page for GPS tracking features and maps.
      </Typography>
    </Box>
  );
};

export default GPSTracking;